<!--
 * @Author: Soul
 * @Date: 2021-06-25 17:23:14
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-07-11 18:11:05
 * @Description: file content
-->
<template>
    <div class="bg">
      <BaseImg :option="{
        style: {
          margin: '14px 0 0 12px',
          alignSelf: 'flex-start',
          width: '149px',
        },
        url: 'logo.png',
      }"/>
      <BaseImg :option="{
        style: {
          margin: '28px auto 0',
        },
        url: 'slogan.png',
      }"/>
      <div class="rules-box">
        <div class="r-body">
          1:进入游戏，点击屏幕控制水枪射击前方元素。击中水元素得100分，击中障碍物则扣50分，20秒游戏时间内达到1000分即可通关，获得抽奖机会。
          <br />2.每人默认2次游戏机会，首次通关后将获得连续两次抽奖机会。机会使用完毕后、还可继续传播活动给好友，即可获得更多游戏次数，通关即可继续参与抽奖。首次传播活动还可收获额外金喜～
          <br />3.当好友通过您的分享参与游戏，您还将自动成为队长，与你的好友组成战队，战队积分为战队所有成员最高游戏得分之和。冲击战队排行榜，还可赢取更多豪礼！
          <br />
          <br /><span>活动时间：</span>
          <br />2022年7月12日09:00—7月16日24:00
          <br /><span>领奖时间：</span>
          <br />2022年7月17日9:00—2022年7月31日24:00
          <br /><span>领奖方式：</span>线上领取，礼品快递邮寄
        </div>
      </div>
      <BaseBtnHome></BaseBtnHome>
    </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {
    };
  },
  created() {},
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {},
};
</script>

<style lang='scss' scoped>
.bg {
  padding-bottom: 135px;
  background: url( $imgHost + 'rule_bottom.png?v=' + $OSSVersion) 0 bottom / 100% no-repeat, url( $imgHost + 'rule_bg.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
  .rules-box {
    margin: 0 auto 0;
    position: relative;
    z-index: 2;
    padding: 92px 35px 0;
    width: 353px;
    height: 517px;
    background: url( $imgHost + 'rule_box.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    .r-body {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 20px;
      text-shadow: 0px 0px 6px rgba(2,126,231,0.7600);
      text-align: justify;
      text-justify: inter-ideograph;
      span {
        font-weight: bold;
      }
    }
    .b-bottom {
      margin-top: 8px;
      .table {
        border: 1px solid #FF9566;
        text-align: center;
        margin-top: 10px;
        .th {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: PingFang;
          font-weight: bold;
          color: #FF6E32;
          // background: rgba(255, 255, 255, .2);
          background-color: #FFC8A6;
        }
        .tr {
          display: flex;
          font-size: 11px;
          font-family: PingFang;
          font-weight: 400;
          color: #FF6E32;
          line-height: 14px;
          border-top: 1px solid #FF9566;
        }
        .td {
          flex: 58;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 30px;
          padding: 5px 0;
          &+.td {
            border-left: 1px solid #FF9566;
          }
          &:nth-child(2) {
            flex: 160;
          }
          &:nth-child(3) {
            flex: 89;
          }
        }
      }
    }
    
  }
}
</style>
